export enum RequestParamsEnum {
    IS_ADMIN = 'isAdmin',
}
